/* Base translations · Invite acceptance page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): invite. */
export const I18N_BASE_INVITE = {
  en: {
    invite: {
      acceptTitle: "Accept your invitation",
      description1: "You've been invited to join",
      description2: "as",
      accept: "Create account & join",
    },
  },
  ar: {
    invite: {
      acceptTitle: "قبول الدعوة",
      description1: "لقد تمت دعوتك للانضمام إلى",
      description2: "بصفة",
      accept: "إنشاء حساب والانضمام",
    },
  },
};

export default I18N_BASE_INVITE;
